/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    document.querySelectorAll('.icon__box .icon.svg').forEach(function (el) {
        var icon = el.dataset.icon;
        if (icon) {
            el.setAttribute('style', "-webkit-mask: url('/static/files/icons/" + icon + ".svg') no-repeat center / contain;");
        }
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
